module.exports = __webpack_public_path__ + "img/usdc.1bc59a3a.svg";